/**
 * Generated by orval 🍺
 * Do not edit manually.
 * ViridisChem API
 * API documentation for ViridisChem API
 */

export type ImageRenderFormat =
    (typeof ImageRenderFormat)[keyof typeof ImageRenderFormat];

export const ImageRenderFormat = {
    PNG: "PNG",
    SVG: "SVG",
} as const;
